var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{'hidden': !_vm.loading},attrs:{"id":"loading-indicator"}},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }